import { Box, Typography } from "@mui/material";

const styles = {
    safety: {
        backgroundColor: '#EAEAEA',
        textColor: '#000000',
        label: 'Safety'
    },
    operations: {
        backgroundColor: '#EAEAEA',
        textColor: '#000000',
        label: 'Operations'
    }
}

const AlertCategoryBadge = ({ category }) => {

    const categoryKey = Object.keys(styles).includes(category?.toLowerCase()) ? category?.toLowerCase() : Object.keys(styles)[0];
    const textColor = styles[categoryKey]['textColor'];
    const backgroundColor = styles[categoryKey]['backgroundColor'];
    const label = styles[categoryKey]['label'];

    return (
        <Box
            sx={{
                borderRadius: '4px',
                px: 1,
                py: 0.5,
                bgcolor: backgroundColor,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <Typography variant="fw400s14c494949" sx={{color: textColor, lineHeight: '20px'}}>
                {label}
            </Typography>
        </Box>
    )
}

export default AlertCategoryBadge;
